export const URL_LOGIN: string = `/login`;

export const URL_MAP_VIEW: string = `/map`;

export const URL_LIST_VIEW: string = `/list`;

export const SETTINGS_TAG: string = `/settings`;

export const URL_USER_SETTINGS: string = `${SETTINGS_TAG}/user`;

export const URL_MAP_SETTINGS: string = `${SETTINGS_TAG}/maps`;

export const URL_CATEGORY_SETTINGS: string = `${SETTINGS_TAG}/category`;

export const URL_SCHEMA = `/:schema`;

export const getSchemaFromUrl = () => {
    return window.location.href.split("/")[3];
};
